<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <img alt="Thumbnail" src="./assets/images/sortiment/symbolfotos/thumbnails/S3002_01.jpg"> -->
    <!-- <img alt="Thumbnail2" src="http://localhost:8080/images/sortiment/symbolfotos/thumbnails/S3002_01.jpg"> -->
    <ProductCatalog msg="Willkommen in der Gärtnerei Höller!"/>
  </div>
</template>

<script>
import ProductCatalog from './components/ProductCatalog.vue'

export default {
  name: 'app',
  components: {
    ProductCatalog
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
